export const environment = {
  production: true,
  siteNumber: 1,
  rootClass: 'festy',
  htmlTitle : " - Festy repas du Loup - chef à domicile en Mayenne",
  siteName : 'Festy repas du Loup',
  siteDescribe: 'Offrez-vous les services d’un chef à domicile!'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts